import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { addEventListener as _$addEventListener } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=sat-info-row><span class=sat-info-label>AIRLINE</span><span class=sat-info-value>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class=sat-info-row><span class=sat-info-label>STATUS</span><span class=sat-info-value>On Ground`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class="ship-info-panel plane-info-panel"><div class="sat-info-header plane-info-header"><span class="sat-info-title plane-info-title"></span><button class=sat-info-close>✕</button></div><div class=sat-info-body><div class=sat-info-row><span class=sat-info-label>ICAO24</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>POSITION</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>ALTITUDE</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>SPEED</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>HEADING</span><span class=sat-info-value></span></div><div class=sat-info-row><span class=sat-info-label>V/S</span><span class=sat-info-value></span></div></div><div class="sat-info-footer plane-info-footer"><button class=sat-info-follow-btn></button><a class=ship-info-external-link target=_blank rel=noopener>View on FlightRadar24 ↗`);
/**
 * WorldView - Plane Info Panel (SolidJS)
 * Displays plane/flight metadata when a plane is selected.
 */

import { Show, createMemo } from "solid-js";
import { selection } from "../../stores/selection";
import { formatCoordinates } from "../formatters";
import { useEntityPanel } from "./useEntityPanel";
import { formatAltitude, formatSpeed, formatHeading, formatVerticalRate, getAirlineFromCallsign } from "../../layers/planes/aircraftTypes";

/**
 * PlaneInfo component
 * Displays plane metadata when a plane is selected
 */
export function PlaneInfo() {
  const {
    isFollowing,
    handleFollow,
    handleClose
  } = useEntityPanel("flight");
  const data = createMemo(() => {
    if (selection.type !== "flight") return null;
    return selection.data;
  });
  const airline = createMemo(() => {
    const d = data();
    if (!d) return null;
    return getAirlineFromCallsign(d.callsign);
  });
  return _$createComponent(Show, {
    get when() {
      return data();
    },
    children: flightData => (() => {
      var _el$ = _tmpl$3(),
        _el$2 = _el$.firstChild,
        _el$3 = _el$2.firstChild,
        _el$4 = _el$3.nextSibling,
        _el$5 = _el$2.nextSibling,
        _el$9 = _el$5.firstChild,
        _el$0 = _el$9.firstChild,
        _el$1 = _el$0.nextSibling,
        _el$10 = _el$9.nextSibling,
        _el$11 = _el$10.firstChild,
        _el$12 = _el$11.nextSibling,
        _el$13 = _el$10.nextSibling,
        _el$14 = _el$13.firstChild,
        _el$15 = _el$14.nextSibling,
        _el$16 = _el$13.nextSibling,
        _el$17 = _el$16.firstChild,
        _el$18 = _el$17.nextSibling,
        _el$19 = _el$16.nextSibling,
        _el$20 = _el$19.firstChild,
        _el$21 = _el$20.nextSibling,
        _el$22 = _el$19.nextSibling,
        _el$23 = _el$22.firstChild,
        _el$24 = _el$23.nextSibling,
        _el$26 = _el$5.nextSibling,
        _el$27 = _el$26.firstChild,
        _el$28 = _el$27.nextSibling;
      _$insert(_el$3, () => flightData().callsign || flightData().icao24);
      _$addEventListener(_el$4, "click", handleClose, true);
      _$insert(_el$5, _$createComponent(Show, {
        get when() {
          return airline();
        },
        get children() {
          var _el$6 = _tmpl$(),
            _el$7 = _el$6.firstChild,
            _el$8 = _el$7.nextSibling;
          _$insert(_el$8, airline);
          return _el$6;
        }
      }), _el$9);
      _$insert(_el$1, () => flightData().icao24.toUpperCase());
      _$insert(_el$12, (() => {
        var _c$ = _$memo(() => !!flightData().position);
        return () => _c$() ? formatCoordinates(flightData().position.lat, flightData().position.lng) : "—";
      })());
      _$insert(_el$15, () => formatAltitude(flightData().position?.alt ?? 0));
      _$insert(_el$18, () => formatSpeed(flightData().velocity));
      _$insert(_el$21, () => formatHeading(flightData().heading));
      _$insert(_el$24, () => formatVerticalRate(flightData().verticalRate));
      _$insert(_el$5, _$createComponent(Show, {
        get when() {
          return flightData().onGround;
        },
        get children() {
          return _tmpl$2();
        }
      }), null);
      _$addEventListener(_el$27, "click", handleFollow, true);
      _$insert(_el$27, () => isFollowing() ? "UNFOLLOW" : "FOLLOW");
      _$effect(() => _$setAttribute(_el$28, "href", `https://www.flightradar24.com/${flightData().callsign || flightData().icao24}`));
      return _el$;
    })()
  });
}
export default PlaneInfo;
_$delegateEvents(["click"]);